import { useQuery } from '@tanstack/react-query';
import { getRecentTransactions } from '../services/banking';

export type RecentTransaction = {
  date?: string;
  account: string;
  type: string;
  amount: number;
  currency: string;
};

interface UseRecentTransactionsParams {
  companyId?: number;
  accountId?: number;
}

export const RECENT_TRANSACTIONS_QUERY_KEY = 'recentTransactions';

export const useRecentTransactions = ({ companyId, accountId }: UseRecentTransactionsParams) => {
  return useQuery<RecentTransaction[]>({
    queryKey: [RECENT_TRANSACTIONS_QUERY_KEY, companyId, accountId],
    queryFn: () => getRecentTransactions(companyId!, accountId!),
    enabled: !!companyId && !!accountId,
  });
};
